export const HANDLE_INPUT_CHANGE = 'HANDLE_INPUT_CHANGE';
export const HANDLE_INPUT_BLUR = 'HANDLE_INPUT_BLUR';
export const TOGGLE_AGREE_TERMS = 'TOGGLE_AGREE_TERMS';
export const UPDATE_SUBMIT_STATE = 'UPDATE_SUBMIT_STATE';

interface IInputState {
  isValid: boolean;
  value: string;
}

export interface IOnboardingState {
  agreeTerms: boolean;
  errorOnBlur: boolean;
  input: IInputState;
  submitted: boolean;
}

export interface IInputAction {
  payload: IInputState;
  type: typeof HANDLE_INPUT_CHANGE;
}

export interface IToggleAction {
  type: typeof TOGGLE_AGREE_TERMS;
}

export interface IBlurAction {
  type: typeof HANDLE_INPUT_BLUR;
}

export interface ISubmitAction {
  submit: boolean;
  type: typeof UPDATE_SUBMIT_STATE;
}

export type OnboardingActionTypes = IInputAction | IToggleAction | IBlurAction | ISubmitAction;

export const onboardingVariants = {
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  USER_SIGNUP: 'user_signup',
  ODDSCHECKER_PLUS_AD: 'oddschecker_plus_ad',
} as const;

export type OnboardingVariant = (typeof onboardingVariants)[keyof typeof onboardingVariants];

export const onboardingView = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
} as const;

export type OnboardingView = (typeof onboardingView)[keyof typeof onboardingView];

export type OnboardingProps = {
  contentServer?: string;
  hasMarginTop?: boolean;
  initLabels?: Record<string, string>;
  variant?: OnboardingVariant;
  view?: OnboardingView;
};
